import { render, staticRenderFns } from "./MdtTextarea.vue?vue&type=template&id=3abfde0e&scoped=true"
import script from "./MdtTextarea.vue?vue&type=script&lang=js"
export * from "./MdtTextarea.vue?vue&type=script&lang=js"
import style0 from "./MdtTextarea.vue?vue&type=style&index=0&id=3abfde0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abfde0e",
  null
  
)

export default component.exports